const ApiAttributesKeys = {
  performanceGraphUserAttemptedCountKey: 'questions_frms.frm_question_stat.userAttemptCount',
  performanceGraphUserAnsweredCountKey: 'questions_frms.frm_question_stat.userAnswerCount',
  chapterNameKey: 'chapter_name',
  attemptedCountKey: 'attempted_count',
  answeredCountKey: 'answered_count',
  questionTableNameKey: 'questions_frms',
  questionStatsTableNameKey: 'frm_question_stat',
  notesTableNameKey: 'frm_notes',
  notesStatsTableNameKey: 'frm_notes_stat',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Dashboard/ApiAttributesKays.js